import { render, staticRenderFns } from "./editListTable.vue?vue&type=template&id=1f8f63dc&scoped=true&"
import script from "./editListTable.vue?vue&type=script&lang=js&"
export * from "./editListTable.vue?vue&type=script&lang=js&"
import style0 from "./editListTable.vue?vue&type=style&index=0&id=1f8f63dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f63dc",
  null
  
)

export default component.exports